<template>
  <el-card
    id="paymentSettingCard"
    class="mainCard clear-card is-hover-shadow"
  >
    <!-- Title -->
    <div class="title">
      <div class="left">
        <div class="mainTitle">
          {{ $t('settings.professionalBg') }}
        </div>
        <span class="thinTitle">
          {{ $t('settings.professionalBgDetail') }}
        </span>
      </div>
      <div class="right">
        <el-button
          class="clearBtn"
          type="plain"
          round
          @click="toggleView"
        >
          <span>
            {{ $t('common.view') }}
          </span>
        </el-button>
      </div>
    </div>

    <LeaderDemographics
      :show.sync="viewDemographics"
      :forced="false"
    />
  </el-card>
</template>

<script>
import LeaderDemographics from '@/views/dashboard/widget/LeaderDemographics.vue';

export default {
  name: 'ProfessionalBackground',

  components: {
    LeaderDemographics,
  },

  data: () => ({
    viewDemographics: false,
  }),

  methods: {
    toggleView() {
      this.viewDemographics = true;
    },
  },
};
</script>

<style lang="scss" scoped>
#paymentSettingCard {
  .title {
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      font-size: 16px;

      .mainTitle {
        padding-right: 8px;
      }

      .thinTitle {
        font-weight: normal;
      }
    }
  }

  .clearBtn {
    // padding: 10px 5px;
    // min-width: 120px;
    background-color: transparent;
    color: var(--themeFontColor);
  }
}
</style>
